import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-products-vesakko',
  templateUrl: './products-vesakko.component.html',
  styleUrls: ['./products-vesakko.component.css']
})
export class ProductsVesakkoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
